import React from 'react';

const Skeleton = ({ className = '' }) => {
  return (
    <div className={`animate-pulse bg-slate-200 rounded-lg ${className}`} />
  );
};

export const ProductSkeleton = () => (
  <div className="bg-white rounded-3xl border-2 border-ink-navy p-6 h-[450px] space-y-4">
    <Skeleton className="h-48 w-full rounded-2xl" />
    <Skeleton className="h-4 w-1/4" />
    <Skeleton className="h-8 w-3/4" />
    <Skeleton className="h-16 w-full" />
    <div className="flex justify-between items-center pt-4">
      <Skeleton className="h-8 w-20" />
      <Skeleton className="h-10 w-24 rounded-xl" />
    </div>
  </div>
);

export default Skeleton;